import { FunctionComponent, useEffect, useState } from 'react'
import styles from './planningInfoDialog.module.scss'
import Dialog from '@/components/_custom/Dialog/Dialog'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import { useTranslation } from 'react-i18next'
import { Daycare } from '@/types/Daycare'
import { useLazyQuery } from '@apollo/client'
import { GET_PLANNING_INFO } from '@/modules/API/daycare/daycareHandler'

interface PlanningInfoDialogProps {
    open: boolean
    handleClose: () => void
    daycare: Daycare
}

const PlanningInfoDialog: FunctionComponent<PlanningInfoDialogProps> = ({ open, handleClose, daycare }) => {
    const { t } = useTranslation()

    const [lastOccasionalSlot, setLastOccasionalSlot] = useState<string>('')
    const [lastRegularSlot, setLastRegularSlot] = useState<string>('')
    const [lastPost, setLastPost] = useState<string>('')
    const [lastEvent, setLastEvent] = useState<string>('')
    const [lastStaffWork, setLastStaffWork] = useState<string>('')
    const [lastConnectionDate, setLastConnectionDate] = useState<string>('')

    const [getLastPlanningInfo, { data: dataPlanningInfo }] = useLazyQuery(GET_PLANNING_INFO, {
        variables: {
            daycareId: daycare.id
        }
    })

    useEffect(() => {
        if (dataPlanningInfo) {
            setLastOccasionalSlot(dataPlanningInfo.getPlanningInfo.lastOccasionalSlot)
            setLastRegularSlot(dataPlanningInfo.getPlanningInfo.lastRegularSlot)
            setLastPost(dataPlanningInfo.getPlanningInfo.lastPost)
            setLastEvent(dataPlanningInfo.getPlanningInfo.lastEvent)
            setLastStaffWork(dataPlanningInfo.getPlanningInfo.lastStaffWork)
            setLastConnectionDate(dataPlanningInfo.getPlanningInfo.lastConnectionDate)
        }
    }, [dataPlanningInfo])

    useEffect(() => {
        if (daycare) {
            getLastPlanningInfo()
        }
    }, [daycare])

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('informations')} />
            <DialogBody className={styles.DialogBody}>
                <div className={styles.Container}>
                    <p>Dernière place occasionnelle : {lastOccasionalSlot} </p>
                    <p>Dernière place régulière : {lastRegularSlot} </p>
                    <p>Dernière publication : {lastPost} </p>
                    <p>Dernier événement : {lastEvent} </p>
                    <p>Dernier jour de travail : {lastStaffWork} </p>
                    <p>Date de la dernière connexion : {lastConnectionDate} </p>
                </div>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon type={'close'} onClick={handleClose} className={styles.Button} />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default PlanningInfoDialog
